import { FC } from "react";
import { IconPropsType } from ".";

export const Enrollment: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 8.5V6.5C10 5.67157 9.32843 5 8.5 5C7.67157 5 7 5.67157 7 6.5V8.5C7 9.32843 7.67157 10 8.5 10C9.32843 10 10 9.32843 10 8.5ZM8.5 4C7.11929 4 6 5.11929 6 6.5V8.5C6 9.88071 7.11929 11 8.5 11C9.88071 11 11 9.88071 11 8.5V6.5C11 5.11929 9.88071 4 8.5 4Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 20V17.5C13 15.0147 10.9853 13 8.5 13C6.01472 13 4 15.0147 4 17.5V20C4 20.5523 4.44772 21 5 21H12C12.5523 21 13 20.5523 13 20ZM8.5 12C5.46243 12 3 14.4624 3 17.5V20C3 21.1046 3.89543 22 5 22H12C13.1046 22 14 21.1046 14 20V17.5C14 14.4624 11.5376 12 8.5 12Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5 5.5V2H17.5V5.5H21V6.5H17.5V10H16.5V6.5H13V5.5H16.5Z"
        fill={props.color}
      />
    </svg>
  );
};
